import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../root.reducer';

export const getCoolerTransactionState = (state: RootState) =>
  state.coolerTransaction;

export const getCoolerTransactionList = createSelector(
  getCoolerTransactionState,
  (coolerTransactionState) => ({
    coolerTransactions: coolerTransactionState.coolerTransactions,
    loading: coolerTransactionState.listLoading,
  }),
);

export const getCoolerSingleTransaction = createSelector(
  getCoolerTransactionState,
  (coolerTransactionState) => ({
    coolerTransaction: coolerTransactionState.coolerTransaction,
    loading: coolerTransactionState.singleLoading,
  }),
);
// Backwards-compatible selector: returns the list loading flag
export const getCoolerTransactionLoading = (state: RootState) =>
  state.coolerTransaction.listLoading;
export const getCoolerTransactionListLoading = (state: RootState) =>
  state.coolerTransaction.listLoading;
export const getCoolerTransactionSingleLoading = (state: RootState) =>
  state.coolerTransaction.singleLoading;
export const getCoolerTransactionError = (state: RootState) =>
  state.coolerTransaction.error;
